export default function Machines_B_2 (number = 1) {
  return {
    name: '极速传送带',
    icon: '/static/img/machines/b2.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_2.js